module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_8023.50f55855.png";